import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import SettingsScreen from ".";
import ListUserType from "./manage-user-type/list-user-type";
import ConfiguracionEmpresa from "./manage-company/manage-company";
import ConfiguracionEmpresaCliente from "./manage-company-client/manage-company-client";
import ManageAccount from "./manage-account/manage-account";

const RouterSettings = () => {
  const { path } = useRouteMatch();
  return (
    // <LayoutConfiguracion>
    <Switch>

      <Route exact path={`${path}`}>
        <SettingsScreen />
      </Route>

      <Route exact path={`${path}/manage-company/manage-company`}>
        <ConfiguracionEmpresa />
      </Route>
      <Route exact path={`${path}/manage-user-type/list-user-type`}>
        <ListUserType />
      </Route>
      <Route exact path={`${path}/manage-company-client/manage-company-client`}>
        <ConfiguracionEmpresaCliente />
      </Route>

      <Route exact path={`${path}/manage-account/manage-account`}>
        <ManageAccount />
      </Route>

    </Switch>
    // </LayoutConfiguracion>
  );
};

export default RouterSettings;
